import { Card, Banner, Bleed, Box, Checkbox, Divider, FormLayout, InlineStack, Layout, SkeletonBodyText, SkeletonDisplayText, SkeletonPage, SkeletonThumbnail, Text, BlockStack, RadioButton, ResourceList, ResourceItem, Listbox } from '@shopify/polaris';
import React from 'react';
import './skeleton.css';
import styles from './skeleton.module.css';
import { Dot } from '../../../../../../Asests/svgIcon/icon';
import Separator from '../CategorySettingsAndAttributes/Categories/Separator';

export const renderSkeletonsValueMapping = () => {
    return (
        <Card roundedAbove='sm' background="bg-surface-secondary">
            <BlockStack gap="500">
                <div>
                    <SkeletonBodyText lines={2} />
                </div>
                <Bleed marginInline="500"><Divider /></Bleed>
                <div>
                    <SkeletonBodyText lines={4} />
                </div>
                <Bleed marginInline="500"><Divider /></Bleed>
                <div>
                    <SkeletonBodyText lines={6} />
                </div>
                <Bleed marginInline="500"><Divider /></Bleed>
                <div>
                    <SkeletonBodyText lines={8} />
                </div>
            </BlockStack>
        </Card>
    );
}

export function SmallSkeleton(props: any) {
    const { type, t } = props;
    return <>
        <Card>
            <Layout>
                {type !== "default" && <Layout.AnnotatedSection title={<Text as='span'>{t("Template Name")} <Text as='span' tone='critical'>*</Text></Text>} description={t("Enter a unique name for the product template you wish to create.")}>
                    <Card roundedAbove='sm' background="bg-surface-secondary">
                        <BlockStack gap="200">
                            <div className='Tempalate_name--skeleton'>
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className='textfield__skeleton'>
                                <SkeletonDisplayText />
                            </div>
                        </BlockStack>
                    </Card>
                </Layout.AnnotatedSection>}
            </Layout>
        </Card>
    </>;
}

export function FullfillmentSkeleton(props: any) {
    const { type, t } = props;
    return (
        <Card>
            <Layout>
                {type !== "default" && <Layout.AnnotatedSection title={<Text as='span'>{t("Fulfilment Type")} <Text as='span' tone='critical'>*</Text></Text>} description={t("Choose your shipping/ fulfilment preference for the selected category.")}>
                    <Card roundedAbove='sm' background="bg-surface-secondary">
                        <BlockStack gap="100">
                            <RadioButton
                                label={<div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>}
                            />
                            <RadioButton
                                label={<div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>}
                            />
                        </BlockStack>
                    </Card>
                </Layout.AnnotatedSection>}
            </Layout>
        </Card>

    )
}

export function CategorySkeleton(props: any) {
    const { type, t } = props;
    return <Card>
        <Layout>
            {type !== "default" && <Layout.AnnotatedSection title={<Text as='span'>{t("Category Settings")} <Text as='span' tone='critical'>*</Text></Text>} description={t("Assign an Amazon category to your Templates, Map your Amazon Category Attributes to your Shopify store product attributes, or set a custom value of your choice. The Amazon Category attributes are dependent on the selected Amazon category & get changed when a different category gets selected.")}>
                <Card roundedAbove='sm' background="bg-surface-secondary">
                    <BlockStack gap="400">
                        <BlockStack gap="100">
                            <InlineStack blockAlign='center'>
                                <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <div className='Polaris-Choice__Descriptions text_skeleton'>
                                <SkeletonBodyText lines={2} />
                            </div>
                        </BlockStack>
                        <div className='Custom__Breadcrumb--Skeleton'>
                            <SkeletonDisplayText />
                        </div>
                        <BlockStack gap="100">
                            <InlineStack gap="200">
                                <div className='textfield__skeletons'>
                                    <SkeletonDisplayText />
                                </div>
                                <div className='button--skeleton'>
                                    <SkeletonDisplayText />
                                </div>
                            </InlineStack>
                            <div className='serach_text'>
                                <SkeletonBodyText lines={1} />
                            </div>
                        </BlockStack>
                        <BlockStack gap="500">
                            <Separator />
                            <Card padding='0'>
                                <ResourceList
                                    resourceName={{ singular: 'customer', plural: 'customers' }}
                                    items={[
                                        {
                                            id: '1',
                                            name: <SkeletonBodyText lines={1} />,
                                            url: '#',
                                        },
                                        {
                                            id: '2',
                                            name: <SkeletonBodyText lines={1} />,
                                            url: '#',
                                        },
                                        {
                                            id: '3',
                                            name: <SkeletonBodyText lines={1} />,
                                            url: '#',
                                        },
                                        {
                                            id: '4',
                                            name: <SkeletonBodyText lines={1} />,
                                            url: '#',
                                        },
                                        {
                                            id: '5',
                                            name: <SkeletonBodyText lines={1} />,
                                            url: '#',
                                        },
                                    ]}
                                    renderItem={(item) => {
                                        const { id, name, url } = item;

                                        return (
                                            <ResourceItem
                                                id={id}
                                                url={url}
                                            >
                                                {name}
                                            </ResourceItem>
                                        );
                                    }}
                                />
                            </Card>
                        </BlockStack>
                    </BlockStack>
                </Card>
            </Layout.AnnotatedSection>}
        </Layout>
    </Card>

}
export function InventorySkeleton(props: any) {
    const { t } = props;
    return <Card>
        <Layout>
            <Layout.AnnotatedSection title={t("Inventory Settings")} description={t("This section allows you to increase or decrease your inventory values as per your requirements on the basis of a fixed value.")}>
                <Card background='bg-surface-secondary'>
                    <BlockStack gap="500">
                        <InlineStack blockAlign='center'>
                            <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                        </InlineStack>
                        <Bleed marginInline="500"><Divider /></Bleed>
                        <BlockStack gap="200">
                            <InlineStack blockAlign='center'>
                                <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <div className='Polaris-Choice__Descriptions text_skeleton'>
                                <SkeletonBodyText lines={2} />
                            </div>
                            <BlockStack gap="100">
                                <div className='Tempalate_name--skeleton'>
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <div className='textfield__skeleton'>
                                    <SkeletonDisplayText />
                                </div>
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                            <InlineStack blockAlign='center'>
                                <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <div className='Polaris-Choice__Descriptions text_skeleton'>
                                <SkeletonBodyText lines={2} />
                            </div>
                            <InlineStack blockAlign='center'>
                                <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <div className='Polaris-Choice__Descriptions text_skeleton'>
                                <SkeletonBodyText lines={2} />
                            </div>
                            <InlineStack blockAlign='center'>
                                <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <div className='Polaris-Choice__Descriptions text_skeleton'>
                                <SkeletonBodyText lines={2} />
                            </div>
                            <InlineStack blockAlign='center'>
                                <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <div className='Polaris-Choice__Descriptions text_skeleton'>
                                <SkeletonBodyText lines={2} />
                            </div>
                        </BlockStack>
                        <Bleed marginInline="500"><Divider /></Bleed>
                        <BlockStack gap="200">
                            <div className='Tempalate_name--skeleton'>
                                <SkeletonBodyText lines={1} />
                            </div>
                            <InlineStack blockAlign='center'>
                                <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <InlineStack blockAlign='center'>
                                <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                        </BlockStack>
                    </BlockStack>
                </Card>
            </Layout.AnnotatedSection>
        </Layout>
    </Card>
}
export function PriceSkeleton(props: any) {
    const { t } = props;
    return <Card>
        <Layout>
            <Layout.AnnotatedSection title={t("Price Settings")} description={t("Manage the price for your products from this setting. Be it fixed price or percentage price (increase/decrease) whatever price setting you choose will be synced to Amazon.")}>
                <Card background='bg-surface-secondary'>
                    <BlockStack gap="500">
                        <InlineStack blockAlign='center'>
                            <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                        </InlineStack>
                        <Bleed marginInline="500"><Divider /></Bleed>
                        <div className="Custom__PriceCalc--Skeleton">
                            <InlineStack gap="400" blockAlign="start">
                                <SkeletonThumbnail size="extraSmall" />
                                <BlockStack gap="100">
                                    <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                    <SkeletonBodyText lines={3} />
                                </BlockStack>
                            </InlineStack>
                        </div>
                        <Bleed marginInline="500"><Divider /></Bleed>
                        <BlockStack gap="300">
                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            <FormLayout>
                                <FormLayout.Group>
                                    <BlockStack gap="200">
                                        <div className='Tempalate_name--skeleton'>
                                            <SkeletonBodyText lines={1} />
                                        </div>
                                        <div className='textfield__skeleton'>
                                            <SkeletonDisplayText />
                                        </div>
                                    </BlockStack>
                                    <BlockStack gap="200">
                                        <div className='Tempalate_name--skeleton'>
                                            <SkeletonBodyText lines={1} />
                                        </div>
                                        <div className='textfield__skeleton'>
                                            <SkeletonDisplayText />
                                        </div>
                                    </BlockStack>
                                </FormLayout.Group>
                            </FormLayout>
                        </BlockStack>
                        <Bleed marginInline="500"><Divider /></Bleed>
                        <BlockStack gap="200">
                            <InlineStack blockAlign='center'>
                                <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <InlineStack blockAlign='center'>
                                <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <InlineStack blockAlign='center'>
                                <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                        </BlockStack>
                    </BlockStack>
                </Card>
            </Layout.AnnotatedSection>
        </Layout>
    </Card>

}
export function ProductSkeleton(props: any) {
    const { t } = props;
    return <Card>
        <Layout>
            <Layout.AnnotatedSection title={t("Product Settings")} description={t("Enable syncing of product details and images.")}>
                <Card roundedAbove='sm' background='bg-surface-secondary'>
                    <BlockStack gap="500">
                        <BlockStack gap="300">
                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            <BlockStack gap="200">
                                <InlineStack blockAlign='center'>
                                    <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                    <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                </InlineStack>
                                <InlineStack blockAlign='center'>
                                    <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                    <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                </InlineStack>
                            </BlockStack>
                        </BlockStack>
                        <BlockStack gap="100">
                            <div className='Tempalate_name--skeleton'>
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className='textfield__skeleton'>
                                <SkeletonDisplayText />
                            </div>
                            <SkeletonBodyText lines={4} />
                        </BlockStack>
                    </BlockStack>
                </Card>
            </Layout.AnnotatedSection>
        </Layout>
    </Card>

}
export function dropdownSkeleton() {
    return <BlockStack gap="500">
        <div className='dropdown_skelelton first-drop'>
            <SkeletonBodyText lines={1} />
        </div>
        <Divider />
        <div className='dropdown_skelelton'>
            <SkeletonBodyText lines={1} />
        </div>
        <Divider />
        <div className='dropdown_skelelton'>
            <SkeletonBodyText lines={1} />
        </div>
        <Divider />
        <div className='dropdown_skelelton'>
            <SkeletonBodyText lines={1} />
        </div>
        <Divider />
        <div className='dropdown_skelelton'>
            <SkeletonBodyText lines={1} />
        </div>
        <Divider />
        <div className='dropdown_skelelton'>
            <SkeletonBodyText lines={1} />
        </div>
        <Divider />
        <div className='dropdown_skelelton'>
            <SkeletonBodyText lines={1} />
        </div>
        <Divider />
        <div className='dropdown_skelelton'>
            <SkeletonBodyText lines={1} />
        </div>
        <Divider />
    </BlockStack>
}
export function largeSkeleton() {
    return <BlockStack gap="500">
        <Card roundedAbove='sm' background='bg-surface-secondary'>
            <BlockStack gap="500">
                <InlineStack align="space-between" blockAlign='center'>
                    <div className="Custom__Heading--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>
                    <div className='Tempalate_name--skeleton'>
                        <SkeletonBodyText lines={1} />
                    </div>
                </InlineStack>
                <BlockStack gap="400">
                    <SkeletonBodyText lines={2} />
                    <Card>
                        <InlineStack gap="400" blockAlign='start'>
                            <div className="Custom__PriceCalc--Skeleton">
                                <SkeletonThumbnail size="extraSmall" />
                            </div>
                            <BlockStack gap="100">
                                <div className="Custom__Heading--Skeleton">
                                    <SkeletonDisplayText size="small" />
                                </div>
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </InlineStack>
                    </Card>
                    <Divider />
                    <Card>
                        <InlineStack gap="400" blockAlign='start'>
                            <div className="Custom__PriceCalc--Skeleton">
                                <SkeletonThumbnail size="extraSmall" />
                            </div>
                            <BlockStack gap="100">
                                <div className="Custom__Heading--Skeleton">
                                    <SkeletonDisplayText size="small" />
                                </div>
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </InlineStack>
                    </Card>
                    <Divider />
                    <Card>
                        <InlineStack gap="400" blockAlign='start'>
                            <div className="Custom__PriceCalc--Skeleton">
                                <SkeletonThumbnail size="extraSmall" />
                            </div>
                            <BlockStack gap="100">
                                <div className="Custom__Heading--Skeleton">
                                    <SkeletonDisplayText size="small" />
                                </div>
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </InlineStack>
                    </Card>
                    <Divider />
                    <Card>
                        <InlineStack gap="400" blockAlign='start'>
                            <div className="Custom__PriceCalc--Skeleton">
                                <SkeletonThumbnail size="extraSmall" />
                            </div>
                            <BlockStack gap="100">
                                <div className="Custom__Heading--Skeleton">
                                    <SkeletonDisplayText size="small" />
                                </div>
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </InlineStack>
                    </Card>
                    <Divider />
                    <Card>
                        <InlineStack gap="400" blockAlign='start'>
                            <div className="Custom__PriceCalc--Skeleton">
                                <SkeletonThumbnail size="extraSmall" />
                            </div>
                            <BlockStack gap="100">
                                <div className="Custom__Heading--Skeleton">
                                    <SkeletonDisplayText size="small" />
                                </div>
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </InlineStack>
                    </Card>
                    <Divider />
                    <Card>
                        <InlineStack gap="400" blockAlign='start'>
                            <div className="Custom__PriceCalc--Skeleton">
                                <SkeletonThumbnail size="extraSmall" />
                            </div>
                            <BlockStack gap="100">
                                <div className="Custom__Heading--Skeleton">
                                    <SkeletonDisplayText size="small" />
                                </div>
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </InlineStack>
                    </Card>
                    <Divider />
                    <Card>
                        <InlineStack gap="400" blockAlign='start'>
                            <div className="Custom__PriceCalc--Skeleton">
                                <SkeletonThumbnail size="extraSmall" />
                            </div>
                            <BlockStack gap="100">
                                <div className="Custom__Heading--Skeleton">
                                    <SkeletonDisplayText size="small" />
                                </div>
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </InlineStack>
                    </Card>
                </BlockStack>
            </BlockStack>
        </Card>
        <Card roundedAbove='sm' background='bg-surface-secondary'>
            <BlockStack gap="500">
                <InlineStack align="space-between" blockAlign='center'>
                    <div className="Custom__Heading--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>
                    <div className='Tempalate_name--skeleton'>
                        <SkeletonBodyText lines={1} />
                    </div>
                </InlineStack>
                <Banner>
                    <SkeletonBodyText lines={2} />
                </Banner>
            </BlockStack>
        </Card>
    </BlockStack>
}
export function AttributeSkeleton(props: any) {
    const { type, t } = props;
    return <Card>
        <Layout>
            {type !== "default" && <Layout.AnnotatedSection title={<Text as='span'> {t("Attributes")} <Text as='span' tone='critical'>*</Text></Text>} description={t("Based on the ‘Product Category’ selected, you will have to map the Amazon attribute's value with your Shopify once, or you can set a custom valid value. There are two types of attributes:")}>
                <BlockStack gap="500">
                    <Card roundedAbove='sm' background='bg-surface-secondary'>
                        <BlockStack gap="500">
                            <InlineStack align="space-between" blockAlign='center'>
                                <div className="Custom__Heading--Skeleton">
                                    <SkeletonDisplayText size="small" />
                                </div>
                                <div className='Tempalate_name--skeleton'>
                                    <SkeletonBodyText lines={1} />
                                </div>
                            </InlineStack>
                            <BlockStack gap="400">
                                <SkeletonBodyText lines={2} />
                                <Card>
                                    <InlineStack gap="400" blockAlign='start'>
                                        <div className="Custom__PriceCalc--Skeleton">
                                            <SkeletonThumbnail size="extraSmall" />
                                        </div>
                                        <BlockStack gap="100">
                                            <div className="Custom__Heading--Skeleton">
                                                <SkeletonDisplayText size="small" />
                                            </div>
                                            <SkeletonBodyText lines={1} />
                                        </BlockStack>
                                    </InlineStack>
                                </Card>
                                <Divider />
                                <Card>
                                    <InlineStack gap="400" blockAlign='start'>
                                        <div className="Custom__PriceCalc--Skeleton">
                                            <SkeletonThumbnail size="extraSmall" />
                                        </div>
                                        <BlockStack gap="100">
                                            <div className="Custom__Heading--Skeleton">
                                                <SkeletonDisplayText size="small" />
                                            </div>
                                            <SkeletonBodyText lines={1} />
                                        </BlockStack>
                                    </InlineStack>
                                </Card>
                                <Divider />
                                <Card>
                                    <InlineStack gap="400" blockAlign='start'>
                                        <div className="Custom__PriceCalc--Skeleton">
                                            <SkeletonThumbnail size="extraSmall" />
                                        </div>
                                        <BlockStack gap="100">
                                            <div className="Custom__Heading--Skeleton">
                                                <SkeletonDisplayText size="small" />
                                            </div>
                                            <SkeletonBodyText lines={1} />
                                        </BlockStack>
                                    </InlineStack>
                                </Card>
                                <Divider />
                                <Card>
                                    <InlineStack gap="400" blockAlign='start'>
                                        <div className="Custom__PriceCalc--Skeleton">
                                            <SkeletonThumbnail size="extraSmall" />
                                        </div>
                                        <BlockStack gap="100">
                                            <div className="Custom__Heading--Skeleton">
                                                <SkeletonDisplayText size="small" />
                                            </div>
                                            <SkeletonBodyText lines={1} />
                                        </BlockStack>
                                    </InlineStack>
                                </Card>
                                <Divider />
                                <Card>
                                    <InlineStack gap="400" blockAlign='start'>
                                        <div className="Custom__PriceCalc--Skeleton">
                                            <SkeletonThumbnail size="extraSmall" />
                                        </div>
                                        <BlockStack gap="100">
                                            <div className="Custom__Heading--Skeleton">
                                                <SkeletonDisplayText size="small" />
                                            </div>
                                            <SkeletonBodyText lines={1} />
                                        </BlockStack>
                                    </InlineStack>
                                </Card>
                                <Divider />
                                <Card>
                                    <InlineStack gap="400" blockAlign='start'>
                                        <div className="Custom__PriceCalc--Skeleton">
                                            <SkeletonThumbnail size="extraSmall" />
                                        </div>
                                        <BlockStack gap="100">
                                            <div className="Custom__Heading--Skeleton">
                                                <SkeletonDisplayText size="small" />
                                            </div>
                                            <SkeletonBodyText lines={1} />
                                        </BlockStack>
                                    </InlineStack>
                                </Card>
                                <Divider />
                                <Card>
                                    <InlineStack gap="400" blockAlign='start'>
                                        <div className="Custom__PriceCalc--Skeleton">
                                            <SkeletonThumbnail size="extraSmall" />
                                        </div>
                                        <BlockStack gap="100">
                                            <div className="Custom__Heading--Skeleton">
                                                <SkeletonDisplayText size="small" />
                                            </div>
                                            <SkeletonBodyText lines={1} />
                                        </BlockStack>
                                    </InlineStack>
                                </Card>
                            </BlockStack>
                        </BlockStack>
                    </Card>
                    <Card roundedAbove='sm' background='bg-surface-secondary'>
                        <BlockStack gap="500">
                            <InlineStack align="space-between" blockAlign='center'>
                                <div className="Custom__Heading--Skeleton">
                                    <SkeletonDisplayText size="small" />
                                </div>
                                <div className='Tempalate_name--skeleton'>
                                    <SkeletonBodyText lines={1} />
                                </div>
                            </InlineStack>
                            <Banner>
                                <SkeletonBodyText lines={2} />
                            </Banner>
                        </BlockStack>
                    </Card>
                </BlockStack>
            </Layout.AnnotatedSection>}
        </Layout>
    </Card>

}
export function jsonAttributesSkeleton() {
    return <Card background='bg-surface-secondary'>
        <BlockStack gap="500">
            <InlineStack gap="200" wrap={false}>
                <div className="rounded-skeleton">
                    <SkeletonDisplayText />
                </div>
                <div style={{ width: '100%', maxWidth: '75%' }}>
                    <div className="Custom__Heading--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>
                    <div className="mt-16">
                        <SkeletonBodyText lines={2} />
                    </div>
                </div>
            </InlineStack>
            <SkeletonDisplayText maxWidth="100%" size="medium" />
            <Divider />
            <Layout>
                <Layout.Section variant="oneThird">
                    <Listbox>
                        {
                            Array.from({ length: 5 }, (_, index) => (
                                <Listbox.Option value="ProductIdentity" key={index}>
                                    <Listbox.TextOption>
                                        <div className='custom-listing_items Custom__Heading--Skeleton'>
                                            <SkeletonDisplayText maxWidth="100%" size="small" />
                                        </div>
                                    </Listbox.TextOption>
                                </Listbox.Option>
                            ))
                        }
                    </Listbox>
                </Layout.Section>
                <Layout.Section>
                    <BlockStack gap="500">
                        <BlockStack gap="400">
                            <div style={{ width: '100%' }}>
                                <div className="Custom__Heading--Skeleton">
                                    <SkeletonDisplayText size="small" />
                                </div>
                                <div className="mt-16">
                                    <SkeletonBodyText lines={2} />
                                </div>
                            </div>
                            <Divider />
                            <BlockStack gap="300">
                                <Card roundedAbove='xs'>
                                    <BlockStack gap="300">
                                        <div style={{ width: '100%' }}>
                                            <div className="Custom__Heading--Skeleton">
                                                <SkeletonDisplayText size="small" />
                                            </div>
                                            <div className="mt-16">
                                                <SkeletonBodyText lines={2} />
                                            </div>
                                        </div>
                                        <Divider />
                                        <InlineStack align='end'>
                                            <div className="Custom__Heading--Skeleton">
                                                <SkeletonDisplayText size="small" />
                                            </div>
                                        </InlineStack>
                                    </BlockStack>
                                </Card>
                                <Card roundedAbove='xs'>
                                    <BlockStack gap="300">
                                        <div style={{ width: '100%' }}>
                                            <div className="Custom__Heading--Skeleton">
                                                <SkeletonDisplayText size="small" />
                                            </div>
                                            <div className="mt-16">
                                                <SkeletonBodyText lines={2} />
                                            </div>
                                        </div>
                                        <Divider />
                                        <InlineStack align='end'>
                                            <div className="Custom__Heading--Skeleton">
                                                <SkeletonDisplayText size="small" />
                                            </div>
                                        </InlineStack>
                                    </BlockStack>
                                </Card>
                            </BlockStack>
                        </BlockStack>
                        <div className="footer-skeleton">
                            <InlineStack gap="300" align='space-between' blockAlign='center'>
                                <SkeletonDisplayText size="small" />
                                <SkeletonDisplayText size="small" />
                                <SkeletonDisplayText size="small" />
                            </InlineStack>
                        </div>
                    </BlockStack>
                </Layout.Section>
            </Layout>
        </BlockStack>
    </Card>
}
export function FilterSkelton(props: any) {
    const { type, t } = props;
    return <Card>
        <Layout>
            {type !== "default" && <Layout.AnnotatedSection title={<Text as='span'> {t("Filter Products")} <Text as='span' tone='critical'>*</Text></Text>} description={t("Intro: Craft rules to efficiently filter, group, and assign Shopify products to your newly created template.")}>
                <Card roundedAbove='sm' background='bg-surface-secondary'>
                    <BlockStack gap='400'>
                        <BlockStack gap="100">
                            <InlineStack blockAlign='center'>
                                <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <div className='Polaris-Choice__Descriptions text_skeleton'>
                                <SkeletonBodyText lines={1} />
                            </div>
                        </BlockStack>
                        <Bleed marginInline='500'><Divider /></Bleed>
                        <BlockStack gap='500'>
                            <BlockStack gap="300">
                                <BlockStack gap="200">
                                    <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                    <div className='text_skeleton'>
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                </BlockStack>
                                <InlineStack gap="400">
                                    <div className='Custom-Stack-Item--fill Custom__Search--Skeleton'>
                                        <SkeletonDisplayText size="small" />
                                    </div>
                                    <div className='Custom__SearchBtn--Skeleton'>
                                        <SkeletonDisplayText size="small" />
                                    </div>
                                </InlineStack>
                            </BlockStack>
                            <SkeletonBodyText lines={1} />
                            <BlockStack gap="300">
                                <InlineStack gap="400" align='space-between' blockAlign='center'>
                                    <InlineStack gap="500" align='space-between' blockAlign='center'>
                                        <InlineStack gap="200" blockAlign='center'>
                                            <SkeletonThumbnail size="small" />
                                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                        </InlineStack>
                                        <div className='Custom__badge--Skeleton'>
                                            <SkeletonDisplayText size="small" />
                                        </div>
                                    </InlineStack>
                                    <div className="Custom__PriceCalc--Skeleton">
                                        <SkeletonThumbnail size="extraSmall" />
                                    </div>
                                </InlineStack>
                                <InlineStack gap="400" align='space-between' blockAlign='center'>
                                    <InlineStack gap="500" align='space-between' blockAlign='center'>
                                        <InlineStack gap="200" blockAlign='center'>
                                            <SkeletonThumbnail size="small" />
                                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                        </InlineStack>
                                        <div className='Custom__badge--Skeleton'>
                                            <SkeletonDisplayText size="small" />
                                        </div>
                                    </InlineStack>
                                    <div className="Custom__PriceCalc--Skeleton">
                                        <SkeletonThumbnail size="extraSmall" />
                                    </div>
                                </InlineStack>
                                <InlineStack gap="400" align='space-between' blockAlign='center'>
                                    <InlineStack gap="500" align='space-between' blockAlign='center'>
                                        <InlineStack gap="200" blockAlign='center'>
                                            <SkeletonThumbnail size="small" />
                                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                        </InlineStack>
                                        <div className='Custom__badge--Skeleton'>
                                            <SkeletonDisplayText size="small" />
                                        </div>
                                    </InlineStack>
                                    <div className="Custom__PriceCalc--Skeleton">
                                        <SkeletonThumbnail size="extraSmall" />
                                    </div>
                                </InlineStack>
                                <InlineStack gap="400" align='space-between' blockAlign='center'>
                                    <InlineStack gap="500" align='space-between' blockAlign='center'>
                                        <InlineStack gap="200" blockAlign='center'>
                                            <SkeletonThumbnail size="small" />
                                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                        </InlineStack>
                                        <div className='Custom__badge--Skeleton'>
                                            <SkeletonDisplayText size="small" />
                                        </div>
                                    </InlineStack>
                                    <div className="Custom__PriceCalc--Skeleton">
                                        <SkeletonThumbnail size="extraSmall" />
                                    </div>
                                </InlineStack>
                                <InlineStack gap="400" align='space-between' blockAlign='center'>
                                    <InlineStack gap="500" align='space-between' blockAlign='center'>
                                        <InlineStack gap="200" blockAlign='center'>
                                            <SkeletonThumbnail size="small" />
                                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                        </InlineStack>
                                        <div className='Custom__badge--Skeleton'>
                                            <SkeletonDisplayText size="small" />
                                        </div>
                                    </InlineStack>
                                    <div className="Custom__PriceCalc--Skeleton">
                                        <SkeletonThumbnail size="extraSmall" />
                                    </div>
                                </InlineStack>
                            </BlockStack>
                        </BlockStack>
                    </BlockStack>
                </Card>
            </Layout.AnnotatedSection>}
        </Layout>
    </Card>

}
export function dataGridSkeleton() {
    return <Card roundedAbove='sm' background='bg-surface-secondary'>
        <BlockStack gap="500">
            <InlineStack gap="400">
                <div className='Custom-Stack-Item--fill'><SkeletonDisplayText size="medium" /></div>
                <div className='Custom-Stack-Item--fill'><SkeletonDisplayText size="medium" /></div>
                <div className='Custom-Stack-Item--fill'><SkeletonDisplayText size="medium" /></div>
                <div className='Custom-Stack-Item--fill'><SkeletonDisplayText size="medium" /></div>
                <div className='Custom-Stack-Item--fill'><SkeletonDisplayText size="medium" /></div>
            </InlineStack><hr />
            <BlockStack gap="800">
                <InlineStack gap="800">
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                </InlineStack>
                <InlineStack gap="800">
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                </InlineStack>
                <InlineStack gap="800">
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                    <div className='Custom-Stack-Item--fill'><SkeletonBodyText lines={1} /></div>
                </InlineStack>
            </BlockStack>
        </BlockStack>
    </Card>
}
export function categorySkeleton() {
    return <>
        <Card roundedAbove='sm'>
            <BlockStack gap="400">
                <BlockStack gap="100">
                    <InlineStack blockAlign='center'>
                        <Checkbox label="" id='temlate_Checkbox_Barcode/GTIN Exemption' />
                        <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                    </InlineStack>
                    <div className='Polaris-Choice__Descriptions text_skeleton'>
                        <SkeletonBodyText lines={2} />
                    </div>
                </BlockStack>
                <div className='Custom__Breadcrumb--Skeleton'>
                    <SkeletonDisplayText />
                </div>
                <BlockStack gap="100">
                    <InlineStack gap="200">
                        <div className='textfield__skeletons'>
                            <SkeletonDisplayText />
                        </div>
                        <div className='button--skeleton'>
                            <SkeletonDisplayText />
                        </div>
                    </InlineStack>
                    <div className='serach_text'>
                        <SkeletonBodyText lines={1} />
                    </div>
                </BlockStack>
                <BlockStack gap="500">
                    <Separator />
                    <Card padding='0'>
                        <ResourceList
                            resourceName={{ singular: 'customer', plural: 'customers' }}
                            items={[
                                {
                                    id: '1',
                                    name: <SkeletonBodyText lines={1} />,
                                    url: '#',
                                },
                                {
                                    id: '2',
                                    name: <SkeletonBodyText lines={1} />,
                                    url: '#',
                                },
                                {
                                    id: '3',
                                    name: <SkeletonBodyText lines={1} />,
                                    url: '#',
                                },
                                {
                                    id: '4',
                                    name: <SkeletonBodyText lines={1} />,
                                    url: '#',
                                },
                                {
                                    id: '5',
                                    name: <SkeletonBodyText lines={1} />,
                                    url: '#',
                                },
                            ]}
                            renderItem={(item) => {
                                const { id, name, url } = item;

                                return (
                                    <ResourceItem
                                        id={id}
                                        url={url}
                                    >
                                        {name}
                                    </ResourceItem>
                                );
                            }}
                        />
                    </Card>
                </BlockStack>
            </BlockStack>
        </Card >
    </>;
}
export function attributeSkeleton() {
    return <>
        <BlockStack gap="500">
            <Card roundedAbove='sm'>
                <BlockStack gap="500">
                    <InlineStack align="space-between" blockAlign='center'>
                        <div className="Custom__Heading--Skeleton">
                            <SkeletonDisplayText size="small" />
                        </div>
                        <div className='Tempalate_name--skeleton'>
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                    <BlockStack gap="400">
                        <SkeletonBodyText lines={2} />
                        <Card>
                            <InlineStack gap="400" blockAlign='start'>
                                <div className="Custom__PriceCalc--Skeleton">
                                    <SkeletonThumbnail size="extraSmall" />
                                </div>
                                <BlockStack gap="100">
                                    <div className="Custom__Heading--Skeleton">
                                        <SkeletonDisplayText size="small" />
                                    </div>
                                    <SkeletonBodyText lines={1} />
                                </BlockStack>
                            </InlineStack>
                        </Card>
                        <Divider />
                        <Card>
                            <InlineStack gap="400" blockAlign='start'>
                                <div className="Custom__PriceCalc--Skeleton">
                                    <SkeletonThumbnail size="extraSmall" />
                                </div>
                                <BlockStack gap="100">
                                    <div className="Custom__Heading--Skeleton">
                                        <SkeletonDisplayText size="small" />
                                    </div>
                                    <SkeletonBodyText lines={1} />
                                </BlockStack>
                            </InlineStack>
                        </Card>
                        <Divider />
                        <Card>
                            <InlineStack gap="400" blockAlign='start'>
                                <div className="Custom__PriceCalc--Skeleton">
                                    <SkeletonThumbnail size="extraSmall" />
                                </div>
                                <BlockStack gap="100">
                                    <div className="Custom__Heading--Skeleton">
                                        <SkeletonDisplayText size="small" />
                                    </div>
                                    <SkeletonBodyText lines={1} />
                                </BlockStack>
                            </InlineStack>
                        </Card>
                        <Divider />
                        <Card>
                            <InlineStack gap="400" blockAlign='start'>
                                <div className="Custom__PriceCalc--Skeleton">
                                    <SkeletonThumbnail size="extraSmall" />
                                </div>
                                <BlockStack gap="100">
                                    <div className="Custom__Heading--Skeleton">
                                        <SkeletonDisplayText size="small" />
                                    </div>
                                    <SkeletonBodyText lines={1} />
                                </BlockStack>
                            </InlineStack>
                        </Card>
                        <Divider />
                        <Card>
                            <InlineStack gap="400" blockAlign='start'>
                                <div className="Custom__PriceCalc--Skeleton">
                                    <SkeletonThumbnail size="extraSmall" />
                                </div>
                                <BlockStack gap="100">
                                    <div className="Custom__Heading--Skeleton">
                                        <SkeletonDisplayText size="small" />
                                    </div>
                                    <SkeletonBodyText lines={1} />
                                </BlockStack>
                            </InlineStack>
                        </Card>
                        <Divider />
                        <Card>
                            <InlineStack gap="400" blockAlign='start'>
                                <div className="Custom__PriceCalc--Skeleton">
                                    <SkeletonThumbnail size="extraSmall" />
                                </div>
                                <BlockStack gap="100">
                                    <div className="Custom__Heading--Skeleton">
                                        <SkeletonDisplayText size="small" />
                                    </div>
                                    <SkeletonBodyText lines={1} />
                                </BlockStack>
                            </InlineStack>
                        </Card>
                        <Divider />
                        <Card>
                            <InlineStack gap="400" blockAlign='start'>
                                <div className="Custom__PriceCalc--Skeleton">
                                    <SkeletonThumbnail size="extraSmall" />
                                </div>
                                <BlockStack gap="100">
                                    <div className="Custom__Heading--Skeleton">
                                        <SkeletonDisplayText size="small" />
                                    </div>
                                    <SkeletonBodyText lines={1} />
                                </BlockStack>
                            </InlineStack>
                        </Card>
                    </BlockStack>
                </BlockStack>
            </Card>
            <Card roundedAbove='sm'>
                <BlockStack gap="500">
                    <InlineStack align="space-between" blockAlign='center'>
                        <div className="Custom__Heading--Skeleton">
                            <SkeletonDisplayText size="small" />
                        </div>
                        <div className='Tempalate_name--skeleton'>
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                    <Banner>
                        <SkeletonBodyText lines={2} />
                    </Banner>
                </BlockStack>
            </Card>
        </BlockStack>
    </>;
}
export function advancedSectionSkeleton() {
    return <Card roundedAbove='sm' background='bg-surface-secondary'>
        <BlockStack gap="300">
            <InlineStack>
                <Text as='h2' variant='headingMd'>Adavnced Selection</Text>
            </InlineStack>
            <SkeletonPage primaryAction>
                <Layout>
                    <Layout.Section>
                        <BlockStack gap="500">
                            <BlockStack gap="400">
                                <div><SkeletonDisplayText size="small" /></div>
                                <div><SkeletonBodyText /></div>
                            </BlockStack>
                            <Bleed marginInline="500"><Divider /></Bleed>
                            <BlockStack gap="400">
                                <div><SkeletonDisplayText size="small" /></div>
                                <div><SkeletonBodyText /></div>
                            </BlockStack>
                        </BlockStack>
                    </Layout.Section>
                </Layout>
            </SkeletonPage>
        </BlockStack>
    </Card>
}

export function smallSkeleton() {
    return <>
        <Card roundedAbove='sm'>
            <BlockStack gap="200">
                <div className='Tempalate_name--skeleton'>
                    <SkeletonBodyText lines={1} />
                </div>
                <div className='textfield__skeleton'>
                    <SkeletonDisplayText />
                </div>
            </BlockStack>
        </Card>
    </>;
}